import { useEffect, useState } from "react";
import defaultAvatar from "../../assets/default-avatar.svg";

const isValidUrl = (url) => {
  if (typeof url !== "string") return false;
  const value = url.trim();
  return value.startsWith("http://") || value.startsWith("https://");
};

const SmartImage = ({ src, alt = "", className = "", fallback = defaultAvatar }) => {
  const [imgSrc, setImgSrc] = useState(isValidUrl(src) ? src : fallback);

  useEffect(() => {
    setImgSrc(isValidUrl(src) ? src : fallback);
  }, [src, fallback]);

  const handleError = () => {
    // If fallback also fails, keep current src to avoid retry loop.
    setImgSrc((prev) => (prev === fallback ? prev : fallback));
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={handleError}
    />
  );
};

export default SmartImage;
